export default {
  text: {
    en: 'There is a problem with the address provided.',
  },
  editAddress: {
    en: 'Edit this address',
  },
}
